import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import { CompanyService } from '../../configuration/company/company.service.service';
import { DivisionService } from '../../configuration/division/division.service.service';
import { ICreateMaterialGroup } from './interfaces/create-material-group.interface';
import { IUpdateMaterialGroup } from './interfaces/update-material-group.interface';
import { MaterialGroupService } from './material-group.service';
import DivisionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/division/division.entity";
import MaterialGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-group/material-group.entity';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule, MatRowDef, MatTableDataSource } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { AddBusinessPartnerOrderComponent } from '../../business-partners/business-partner/business-partner-order-modal/business-partner-order.component';
import { MaterialGroupOrderService } from './material-group-order-delivery/material-group-delivery.service';
import { MatTabsModule } from '@angular/material/tabs';
import { DeleteConfirmationComponent } from '../../business-partners/business-partner/delete-modal/delete-modal.component';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from 'app/utils/method';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeModule } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { CdkDragDrop, CdkDropList, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import clonedeep from 'lodash.clonedeep';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { RequirementService } from '../../master/requirement/requirement.service';
import RequirementAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/requirements/requirements.entity';
import { MaterialGroupExport } from './exports/material-group.export';
import { MATERIAL_GROUP_TITLE } from './exports/material-group.constants';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { MaterialsManagementFiltersComponent } from '../../filters/materials-management-filters/materials-management-filters.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";


interface CategoryNode extends MaterialGroupAttributes {
  children?: CategoryNode[];
}

interface CategoryFlatNode extends MaterialGroupAttributes {
  expandable: boolean;
  levelTree: number;
}

@Component({
  selector: 'app-material-group',
  templateUrl: './material-group.component.html',
  styleUrls: ['./material-group.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatTabsModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatTreeModule,
    MatSlideToggleModule,
    NgxMatSelectSearchModule,
    DragDropModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    MaterialsManagementFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    MaterialGroupExport
  ],
})
export class MaterialGroupComponent implements AfterViewInit, OnDestroy {
  getCode = getCode
  modeTree = false

  loadSetPosition = false
  isEditSort = false

  displayedColumns: string[] = ["code", "type", "company", "division", "hasSubcategories", "statusId", "actions"];
  displayedColumnsOrder: string[] = ["days", "hourStart", "hourEnd", "numberOfHoursToDelivery", "statusId", "actions"];
  currentCreateMaterialGroup: ICreateMaterialGroup = this.initializeCreateMaterialGroup();
  currentUpdateMaterialGroup: MaterialGroupAttributes | undefined | any;

  selectedCompanyIds: string[] = [];
  selectedDivisionIds: string[] = [];
  selectfatherCode: string[] = [];
  selectedFatherCode = null;
  resetTrigger: number = 0;

  dataSource = new MatTableDataSource<MaterialGroupAttributes>([]);

  private transformer = (node: CategoryNode, levelTree: number): CategoryFlatNode => {
    return {
      ...node,
      expandable: node.children && node.children.length > 0,
      levelTree: levelTree,
    };
  };

  treeControl = new FlatTreeControl<CategoryFlatNode>(
    node => node.levelTree, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this.transformer, node => node.levelTree,
    node => node.expandable, node => node.children);

  displayedColumnsTree: string[] = ["code", "type", "company", "division", "hasSubcategories", "statusId", "actions"];
  dataSourceTree = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  auxData: MaterialGroupAttributes[] = []
  requirementList: RequirementAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  fatherCodeList: MaterialGroupAttributes[] = [];
  listFilterFatherCode: MaterialGroupAttributes[] = [];
  searchFather = ''

  fatherCodeListFilter: MaterialGroupAttributes[] = [];

  divisionList: DivisionAttributes[] = [];
  searchQuery: string = '';
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 1;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  daysList: { day: string; value: number }[] = [
    { day: "Lunes", value: 1 },
    { day: "Martes", value: 2 },
    { day: "Miércoles", value: 3 },
    { day: "Jueves", value: 4 },
    { day: "Viernes", value: 5 },
    { day: "Sábado", value: 6 },
    { day: "Domingo", value: 7 },
  ];

  typeList: { code: string, name: string }[] = [
    { code: 'N', name: 'NORMAL' }
  ]

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;
  @ViewChild('listGroup', { static: false }) list1: CdkDropList;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: [] = [];
  form: FormGroup;

  loadFiltersData = false;
  private companiesLoaded = false;
  private divisionsLoaded = false;
  private fatherCodesLoaded = false;
  private dataLoadedForModals = false;

  constructor(
    private readonly companyService: CompanyService,
    private readonly divisionService: DivisionService,
    private readonly materialGroupOrderService: MaterialGroupOrderService,
    private readonly materialGroupService: MaterialGroupService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private readonly requirementService: RequirementService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private materialGroupExport: MaterialGroupExport,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId: [],
      divisionId: [],
      materialGroupId: [],
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }
  onMaterialGroupFilterChange(materialGroupId: string): void {
    // Vuelve a la apagina 1
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.pageIndex = 1;

    // Recarga la tabla
    this.findAllWithCount();
  }

  private fetchAllRequirement(): void {
    this.requirementService.findToComboBox().subscribe({
      next: (res) => {
        this.requirementList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener requerimientos.", "Cerrar", { duration: 5000 });
      },
    });
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator ? this.paginator.pageIndex + 1 : 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction ? this.sort.direction === "asc" ? "ASC" : "DESC" : "ASC";

    let dataFilter: IFilters = {
      companyId: this.form.get("companyId")?.value,
      status: this.selectedStatuses ? this.selectedStatuses : null,
      materialGroupId: this.form.get("materialGroupId").value,
      divisionId: this.form.get("divisionId").value
    }

    this.materialGroupService
      .findAllWithCount(
        { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },
        this.form.get("companyId")?.value,
        this.selectedFatherCode,
        dataFilter
      )
      .subscribe((data) => {
        this.auxData = data?.data?.[0]?.data ?? [];
        this.dataSource.data = data?.data?.[0]?.data ?? [];

        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        if (this.paginator) {
          this.paginator.length = this.totalItems;
        }

        // Tree
        let tempTree = []
        let principals = data?.data?.[0]?.data.filter(c => c.fatherCode == '0') //si no se tiene
        for (const c of principals) {
          let node = {
            ...c,
            children: [],
          }

          this.getTree(node, node.code)
          tempTree.push(node)
        }

        this.dataSourceTree.data = tempTree
        //this.expandAllNodesWithChildren()
      });
  }

  getTree(data: CategoryNode, parentIdStr: string) {
    let auxData = this.auxData

    data.children = []
    auxData.forEach(res => {
      if (res.fatherCode == parentIdStr) {
        data.children.push({
          ...res,
          children: [],
        })
      }
    })

    for (let item of data.children) {
      if (item.fatherCode) {
        item.children = []
        this.getTree(item, item.code)
      }
    }
  }

  expandAllNodesWithChildren() {
    const dataNodes = this.treeControl.dataNodes;
    dataNodes.forEach(node => {
      if (node.expandable) {
        this.treeControl.expand(node);  // Expande el nodo si tiene hijos
      }
    });
  }

  private getSortField(): keyof MaterialGroupAttributes {
    const validSortFields: (keyof MaterialGroupAttributes)[] = ["code", "name", "type", "position", "hasSubcategories"];
    return validSortFields.includes(this.sort.active as keyof MaterialGroupAttributes) ? (this.sort.active as keyof MaterialGroupAttributes) : "position";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (!this.modeTree) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    } else {
      const filteredTree = this.filterTree(this.dataSourceTree.data, this.searchQuery);
      this.dataSourceTree.data = filteredTree;
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (!this.modeTree) {
          // this.paginator.pageIndex = 0;
          this.findAllWithCount();
        } else {
          const filteredTree = this.filterTree(this.dataSourceTree.data, this.searchQuery);
          this.dataSourceTree.data = filteredTree;
        }
      });
  }

  private filterTree(nodes: CategoryNode[], filterValue: string): CategoryNode[] {
    return nodes
      .map(node => {
        const filteredChildren = this.filterTree(node.children || [], filterValue);

        // Si el nodo o sus hijos coinciden, mantenemos el nodo
        if (node.name.toLowerCase().includes(filterValue) || filteredChildren.length > 0) {
          return {
            ...node,
            children: filteredChildren, // Mantiene la estructura de los hijos filtrados
          };
        }
        return null; // Elimina el nodo si no coincide
      })
      .filter(node => node !== null);
  }

  //sort
  onListDrop(event: CdkDragDrop<any[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

    if (this.modeTree) {
      const expandedNodes = this.treeControl.dataNodes.filter(node =>
        this.treeControl.isExpanded(node)
      );

      this.dataSourceTree.data = clonedeep(this.dataSourceTree.data);
      this.treeControl.dataNodes.forEach(node => {
        if (expandedNodes.includes(node)) {
          this.treeControl.expand(node);
        }
      });

    } else {
      this.dataSource.data = clonedeep(this.dataSource.data);
    }
  }

  setPosition(event) {
    // Swap the elements around
    this.loadSetPosition = true

    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    // updates moved data and table, but not dynamic if more dropzones
    if (this.modeTree) {
      this.dataSourceTree.data = clonedeep(this.dataSourceTree.data);
    } else {
      this.dataSource.data = clonedeep(this.dataSource.data);
    }
    this.loadSetPosition = false
  }

  onsaveChangesOrder() { //TODO aun no hay varios
    let aux: any[] = []
    let data = this.modeTree ? this.dataSourceTree.data : this.dataSource.data
    data.forEach(element => {
      aux.push(element._id)
    });

    let dataOrder = {
      ids: aux,
    }

    this.materialGroupService.sortGlobal(dataOrder).subscribe({
      next: () => {
        this.findAllWithCount()
        this.isEditSort = false
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    })
  }

  private initializeCreateMaterialGroup(): ICreateMaterialGroup {
    return {
      code: '',
      name: '',
      type: '',
      fatherCode: '0',
      hasSubcategories: false,
      companyId: '',
      divisionId: ''
    };
  }


  getDayNames(days: number[]): string {
    return days
      .map((day) => {
        const foundDay = this.daysList.find((d) => d.value === day);
        return foundDay ? foundDay.day : "";
      })
      .join(", ");
  }

  private fetchAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
        this.companiesLoaded = true;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.", "Cerrar", { duration: 5000 });
      }
    });
  }

  private fetchAllDivisions(): void {
    this.divisionService.findToComboBox().subscribe({
      next: (res) => {
        this.divisionList = res.data;
        this.divisionsLoaded = true;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener al obtener las divisiones.", "Cerrar", { duration: 5000 });
      }
    });
  }

  private fetchAllfatherCodes(): void {
    const paginationOptions = {
      search: '',
      currentPage: 1,
      limitPerPage: 200   // Término de búsqueda que el usuario ingresó
    };
    this.materialGroupService.findToComboBox(paginationOptions).subscribe({
      next: (res) => {
        this.fatherCodeList = res.data[0].data;
        this.listFilterFatherCode = this.fatherCodeList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener codigos padre.", "Cerrar", { duration: 5000 });
      }
    });
  }

  changueOptionsFather(event) {
    if (!this.fatherCodeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterFatherCode = this.fatherCodeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterFatherCode = this.fatherCodeList.filter(item => item.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1)
  }

  getOnlyFather() {
    this.materialGroupService.comboBoxFather(true).subscribe({
      next: (res) => {
        this.fatherCodeListFilter = res.data;
        this.fatherCodesLoaded = true;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener grupo de materiales.", "Cerrar", { duration: 5000 });
      }
    })
  }

  // Método que se activa cuando se selecciona una nueva Compañía
  onCompanySelectionChange(companyId: string): void {
    const selectedCompany = this.companyList.find(company => company._id.toString() === companyId);
    if (this.currentUpdateMaterialGroup && selectedCompany) {
      this.currentUpdateMaterialGroup.company = selectedCompany;
    }
  }

  // Método que se activa cuando se selecciona una nueva División
  onDivisionSelectionChange(divisionId: string): void {
    const selectedDivision = this.divisionList.find(division => division._id.toString() === divisionId);
    if (this.currentUpdateMaterialGroup && selectedDivision) {
      this.currentUpdateMaterialGroup.division = selectedDivision;
    }
  }

  // Método que se activa cuando se selecciona un codigo de padre
  onCodeFatherSelectionChange(fatherId: string): void {
    const selectedFather = this.fatherCodeList.find(father => father._id.toString() === fatherId);
    if (this.currentUpdateMaterialGroup && selectedFather) {
      this.currentUpdateMaterialGroup.fatherCode = selectedFather.code;
    }
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchAllCompanies();
    }
  }

  private ensureDivisionsLoaded(): void {
    if (!this.divisionsLoaded) {
      this.fetchAllDivisions();
    }
  }

  private ensureFatherCodesLoaded(): void {
    if (!this.fatherCodesLoaded) {
      this.getOnlyFather();
    }
  }

  private ensureModalDataLoaded(): void {
    if (!this.dataLoadedForModals) {
      this.fetchAllfatherCodes();
      this.fetchAllRequirement();
      this.dataLoadedForModals = true;
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
    this.ensureDivisionsLoaded();
    this.ensureFatherCodesLoaded();
  }

  openCreateModal(): void {
    this.ensureModalDataLoaded();
    this.currentCreateMaterialGroup = this.initializeCreateMaterialGroup();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createMaterialGroup());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }
  openEditModal(materialGroup: MaterialGroupAttributes): void {
    this.ensureModalDataLoaded();
    const selectedCompany = this.companyList.find(company => company._id === materialGroup.company._id);
    const selectedDivision = this.divisionList.find(division => division._id === materialGroup.division._id);
    const requirement = materialGroup?.requirements?.map((item: any) => item._id);

    this.currentUpdateMaterialGroup = {
      ...materialGroup,
      company: selectedCompany || materialGroup.company,
      division: selectedDivision || materialGroup.division,
      requirements: requirement || materialGroup.requirements,
    };

    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateMaterialGroup(materialGroup._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }


  createMaterialGroup(): void {
    this.materialGroupService.create(this.currentCreateMaterialGroup).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateMaterialGroup(id: string): void {
    if (this.currentUpdateMaterialGroup) {
      const updatedMaterialGroup: IUpdateMaterialGroup = {
        companyId: this.currentUpdateMaterialGroup.company._id.toString(),
        divisionId: this.currentUpdateMaterialGroup.division._id.toString(),
        requirementId: this.currentUpdateMaterialGroup?.requirements?.map((item) =>
          String(item)
        ),
        ...this.currentUpdateMaterialGroup
      };
      this.materialGroupService.update(id, updatedMaterialGroup).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }


  onStatusChange(event: boolean, materialGroup: MaterialGroupAttributes): void {
    const originalStatusId = materialGroup.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedMaterialGroup = { ...materialGroup, statusId: updatedStatusId };

    this.materialGroupService.update(materialGroup._id.toString(), updatedMaterialGroup as any).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        materialGroup.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  // onStatusChange(isActive: boolean, materialGroup: MaterialGroupAttributes): void {
  //   const updatedStatusId = isActive ? 1 : 0;
  //   const updatedMaterialGroup = { ...materialGroup, statusId: updatedStatusId };

  //   this.materialGroupService.update(materialGroup._id.toString(), updatedMaterialGroup).subscribe({
  //     next: () => {
  //       this.snackBar.open('Estado actualizado con éxito', 'Cerrar', { duration: 3000 });
  //       this.findAllWithCount();  // Refrescar la tabla si es necesario
  //     },
  //     error: () => {
  //       materialGroup.statusId = materialGroup.statusId === 1 ? 0 : 1;  // Revertir el cambio en caso de error
  //       this.snackBar.open('Error al actualizar el estado', 'Cerrar', { duration: 3000 });
  //     }
  //   });
  // }

  openDeleteDialog(materialGroup: MaterialGroupAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: materialGroup, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(materialGroup._id.toString()));
  }

  delete(id: string): void {
    this.materialGroupService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  getSelectedCompanyCodes(selectedIds: string[]): number[] {
    return selectedIds.map(
      (id) =>
        this.companyList.find((company) => company._id.toString() === id)?.id
    );
  }

  getSelectedDivisionCodes(selectedDivisionIds: string[]): number[] {
    return selectedDivisionIds.map(id => {
      const division = this.divisionList?.find(division => division._id.toString() === id);
      return division?.id;
    });
  }

  getSelectedFatherCodes(selectedFatherCodes: string[]): string[] {
    return selectedFatherCodes.map(id => {
      const fatherCode = this.fatherCodeList?.find(father => father._id.toString() === id);
      return fatherCode?.code || '';
    });
  }


  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }


  compareByCode(item1: any, item2: any): boolean {
    return item1 && item2 ? item1.code === item2 : item1 === item2;
  }

  openOrderModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerOrderComponent, {
      panelClass: '.form-modal',
      data: existingData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateOrder(result);
        } else {
          this.createOrder(result);
        }
      }
    });
  }
  createOrder(result): void {
    this.materialGroupOrderService.createEmbedded(this.currentUpdateMaterialGroup._id.toString(), result).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.materialGroupOrderService
          .findByMaterialGroupId(this.currentUpdateMaterialGroup._id.toString())
          .subscribe((data) => {
            this.currentUpdateMaterialGroup.orderDeliveryWindows = data?.data;
            this.paginator.length = this.totalItems;
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }
  updateOrder(result): void {
    this.materialGroupOrderService.updateEmbedded(this.currentUpdateMaterialGroup._id.toString(), result._id.toString(), result).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
        this.materialGroupOrderService
          .findByMaterialGroupId(this.currentUpdateMaterialGroup._id.toString())
          .subscribe((data) => {
            this.currentUpdateMaterialGroup.orderDeliveryWindows = data?.data;
            this.paginator.length = this.totalItems;
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }


  onStatusChangeOrder(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerOrder = {
      ...item,
      statusId: updatedStatusId
    }
    this.materialGroupOrderService.updateEmbedded(this.currentUpdateMaterialGroup._id.toString(), item._id.toString(), updatedBusinessPartnerOrder).subscribe({
      next: () => {
        this.materialGroupOrderService
          .findByMaterialGroupId(this.currentUpdateMaterialGroup._id.toString())
          .subscribe((data) => {
            this.currentUpdateMaterialGroup.orderDeliveryWindows = data?.data;
            this.paginator.length = this.totalItems;
          });
      },
      error: () => {
        item.statusId = originalStatusId;
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.materialGroupOrderService
          .findByMaterialGroupId(this.currentUpdateMaterialGroup._id.toString())
          .subscribe((data) => {
            this.currentUpdateMaterialGroup.orderDeliveryWindows = data?.data;
            this.paginator.length = this.totalItems;
          });
      }
    });
  }


  openDeleteOrder(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, { data: item, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.deleteOrder(item));
  }


  deleteOrder(item: any): void {
    this.materialGroupOrderService.deleteEmbedded(this.currentUpdateMaterialGroup._id.toString(),
      item._id.toString(),
      item
    ).subscribe(() => {
      this.snackBar.open("Orden eliminada con éxito", "Cerrar", {
        duration: 3000,
      });
      this.materialGroupOrderService
        .findByMaterialGroupId(this.currentUpdateMaterialGroup._id.toString())
        .subscribe((data) => {
          this.currentUpdateMaterialGroup.orderDeliveryWindows = data?.data;
          this.paginator.length = this.totalItems;
        });
    });
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.selectedDivisionIds = [];
    this.selectedFatherCode = null;
    this.searchQuery = "";
    this.findAllWithCount();
    this.selectedStatuses = [];
    this.searchQuery = "";
    this.form.reset({
      companyId: null,
      divisionId: null,
      materialGroupId: null
    }); //Resetea

    this.resetTrigger++; // Incrementa para forzar detección de cambios
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.pageIndex = 1;
    this.findAllWithCount();
  }

  //exportar
  onExportButtonPressed() {
    if (!this.materialGroupExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: MATERIAL_GROUP_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.materialGroupExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
